import React, { useCallback } from 'react';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { getCardSettings } from 'cards/util/cardSettingsUtils';
import { CARD_TYPES } from 'cards/constants/CardTypes';

import styles from './styles.module.less';

type CloseCustomModalProps = {
  projectType: keyof typeof CARD_TYPES;
  hideModalFn: () => void;
  isDigital?: boolean;
};

const CloseCustomModal = ({
  hideModalFn,
  projectType,
  isDigital = false,
}: CloseCustomModalProps): JSX.Element => {
  const { urlSlug, label } = getCardSettings(projectType, isDigital);
  const goToDrafts = useCallback(() => {
    hideModalFn();
    window.location.href = isDigital
      ? '/wedding-planning/projects/digital'
      : '/wedding-planning/projects/drafts';
  }, [hideModalFn, isDigital]);

  const goToPLP = useCallback(() => {
    hideModalFn();
    window.location.href = `/wedding-planning/${urlSlug}/shop`;
  }, [hideModalFn, urlSlug]);

  return (
    <div className={styles.closeCustomModal}>
      <div className={styles.title} data-testid="modal-title">
        We saved your work
      </div>
      <div className={styles.details}>
        Visit &ldquo;Your Orders + Drafts&rdquo; to continue customizing your design anytime.
      </div>
      <div className={styles.buttons}>
        <ButtonV2 variant="secondary" onClick={goToDrafts} data-testid="view-drafts-button">
          View Drafts
        </ButtonV2>
        <ButtonV2 onClick={goToPLP} data-testid="browse-button">{`Browse ${label}`}</ButtonV2>
      </div>
    </div>
  );
};

export default {
  component: CloseCustomModal,
  options: {
    size: 'md',
  },
};
